import { mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    theme: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      isCategoriesLabelVisible: false,
      swiperOption: {
        roundLengths: true, // Fixes blurry text
        slidesPerView: 8,
        breakpoints: {
          320: { // iPhone 5
            slidesPerView: 3.5,
          },
          640: {
            slidesPerView: 4.5,
          },
          1024: {
            slidesPerView: 6.5,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('browse', ['userBrowseHeaders']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    categoriesIcon() {
      // if (this.isLayoutDesktop) {
      //   return this.iconClassModifiers({ icon: 'globe' });
      // }
      return this.iconClassModifiers({ icon: 'categories' });
    },
    classModifiers() {
      return {
        'nav-browse-old': true,
        [`nav-browse-old--${this.theme}`]: this.theme,
        'nav-browse-old--desktop': !this.isLayoutMobile,
        'nav-browse-old--mobile': this.isLayoutMobile,
        'nav-browse-old--space-between': this.userBrowseHeaders.length >= 3,
      };
    },
  },
  methods: {
    toggleCategoriesLabel() {
      if (this.isLayoutMobile) {
        this.isCategoriesLabelVisible = !this.isCategoriesLabelVisible;
      }
    },
    iconClassModifiers(item) {
      return {
        'nav-browse-old__link-icon': true,
        [`nav-browse-old__link-icon--${item.icon}`]: item.icon,
      };
    },
  },
  mounted() {
    if (this.isLayoutDesktop) {
      this.isCategoriesLabelVisible = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/app-secondary-nav/nav-browse/nav-browse.js